/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradeTaskChange } from './moduleUpgradeTaskChange';
import type { ModuleUpgradeOfferChangeSummary } from './moduleUpgradeOfferChangeSummary';

/**
 * Applicable upgrade offer surfaced to a student pinned to an older module version.
 */
export interface ModuleUpgradeOffer {
  targetVersion: string;
  pinnedVersion: string;
  headline: string;
  impactNotice?: string;
  invalidatesProgress?: boolean;
  autoPromptSuppressed?: boolean;
  removedTasks?: ModuleUpgradeTaskChange[];
  addedTasks?: ModuleUpgradeTaskChange[];
  changeSummary?: ModuleUpgradeOfferChangeSummary;
}
